import Qc2ConfigMatchPage from './Qc2ConfigMatchPage';

export default function RdcConfigMatchPage() {
  return <Qc2ConfigMatchPage captureKind="rdc" />;
}
